export default __webpack_public_path__ + "static/media/timeline-1.51b8ccbf.jpg";